// extracted by mini-css-extract-plugin
module.exports = {"rating":"snwmxQ","hasHalfStar":"_2X8TAi","one":"_22ZYzJ","two":"_303MJb","three":"_3uU3eO","four":"bm0VoL"};